import React from 'react';
import { observer } from 'mobx-react';

import { Container, BackButtonContainer, BackButton } from './Header.styles';
import view from 'modules/ticketPublicPage/stores/tickets/view';

const Header = observer(({ ...rest }) => {
  const { facility } = view;

  const url = facility.website;

  return (
    <Container {...rest}>
      <BackButtonContainer>
        <BackButton $asButton={!!url} href={!!url ? url : null} target="_blank">
          {facility.name}
        </BackButton>
      </BackButtonContainer>
    </Container>
  );
});

export default Header;
